import _ from "lodash";
import staffMapper from "./staffMapper";

const statisticMapper = {
    /**
     * Map array of statistic objects
     * @param {Array} statistics
     * @return {Array}
     */
    mapStatistics: function (statistics) {
        return statistics.map((statistic) => {
            return this.mapStatistic(statistic);
        });
    },

    /**
     * Map statistic object
     * @param {Object} statistic
     * @return {Object}
     */
    mapStatistic: function (statistic) {
        return _.transform(statistic, (result, value, key) => {
            if (key === "staff_sales" && value) {
                value = staffMapper.mapStaff(value);
            } else if (_.isArray(value)) {
                value = value.map((element) =>
                    _.isObject(element)
                        ? _.mapKeys(element, (v, k) => _.camelCase(k))
                        : element
                );
            } else if (_.isObject(value)) {
                value = _.mapKeys(value, (v, k) => _.camelCase(k));
            }
            result[_.camelCase(key)] = value;
        }, {});
    },
};

export default statisticMapper;
